__turbopack_context__.v({
  "caption": "ArticleModuleMediaCollapsibleMetadataBox-module-scss-module__3LyyUq__caption",
  "collapseButton": "ArticleModuleMediaCollapsibleMetadataBox-module-scss-module__3LyyUq__collapseButton",
  "copyright": "ArticleModuleMediaCollapsibleMetadataBox-module-scss-module__3LyyUq__copyright",
  "expanded": "ArticleModuleMediaCollapsibleMetadataBox-module-scss-module__3LyyUq__expanded",
  "hidden": "ArticleModuleMediaCollapsibleMetadataBox-module-scss-module__3LyyUq__hidden",
  "moduleType": "ArticleModuleMediaCollapsibleMetadataBox-module-scss-module__3LyyUq__moduleType",
  "wrapper": "ArticleModuleMediaCollapsibleMetadataBox-module-scss-module__3LyyUq__wrapper",
});
